import { render, staticRenderFns } from "./ShareAltOutlinedIcon.vue?vue&type=template&id=2ce163ea&scoped=true"
import script from "./ShareAltOutlinedIcon.vue?vue&type=script&lang=js"
export * from "./ShareAltOutlinedIcon.vue?vue&type=script&lang=js"
import style0 from "./ShareAltOutlinedIcon.vue?vue&type=style&index=0&id=2ce163ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce163ea",
  null
  
)

export default component.exports